import {ITipoEnvio} from "../../entities/catalogos/ITipoEnvio";

export const SAVE_TIPOS_ENVIO = 'SAVE_TIPOS_ENVIO';

interface ISaveTiposEnvio {
    type: typeof SAVE_TIPOS_ENVIO
    tiposEnvio: ITipoEnvio[]
}

export type TipoEnvioActionTypes = ISaveTiposEnvio
